// any issue here please contact with conjee
// https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
let _mobileSafari = null;
const isMobileSafari = () => {
    if (_mobileSafari === null) {
        _mobileSafari = !!(/safari/i.test(navigator.userAgent) && 'ontouchstart' in window);
    }
    return _mobileSafari;
};

const preventDefault = (event) => {
    //if parent node not include '.overlay' '.dialog' '.mvt-searchbox' then prevent default with vanilla js
    if (
        !event.target.closest('.overlay') &&
        !event.target.closest('.dialog') &&
        !event.target.closest('.mvt-searchbox') &&
        !event.target.closest('.header') &&
        !event.target.closest('[data-role="overlay"]')
    ) {
        event.preventDefault();
    }
};

const disableScroll = () => {
    if (document.body.style.overflow === 'hidden' && document.body.style.height === '100%') {
        return;
    }
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100%';

    window.addEventListener('touchmove', preventDefault, { passive: false });
};

const enableScroll = () => {
    if (document.body.style.overflow === '' && document.body.style.height === '') {
        return;
    }
    document.body.style.overflow = '';
    document.body.style.height = '';

    window.removeEventListener('touchmove', preventDefault);
};

export const openOverlayer = (name) => {
    if (isMobileSafari()) {
        disableScroll();
    }
    document.querySelector('#body').classList.add(name);
};

export const closeOverlayer = (name) => {
    const body = document.querySelector('#body');
    body.classList.remove(name);
    if (isMobileSafari()) {
        if (
            body.classList.contains('overlay-active') ||
            body.classList.contains('aside-active') ||
            body.classList.contains('dialog-active') ||
            body.classList.contains('searchbox-active') ||
            body.classList.contains('popownup-active')
        ) {
            return;
        }
        enableScroll();
    }
};
